let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hv2bE")).then(() => parcelRequire('l9h9Z'));